export default __webpack_public_path__ + "static/media/support-hero-img.64949e65.jpg";